import {Component, inject, signal, ChangeDetectionStrategy} from "@angular/core"
import {FormsModule} from "@angular/forms"
import {MatButtonModule} from "@angular/material/button"
import {MatCheckboxModule} from "@angular/material/checkbox"
import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef} from "@angular/material/dialog"

export type SendToBlenderDialogData = {
    meshCount: number
    meshCurveCount: number
    lightCount: number
    cameraCount: number
    materialCount: number
    hdriCount: number
    renderCount: number
}

export type SendToBlenderDialogResult = {includeMaterials: boolean}

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-send-to-blender-dialog",
    templateUrl: "./send-to-blender-dialog.component.html",
    styleUrls: ["./send-to-blender-dialog.component.scss"],
    imports: [MatDialogModule, MatButtonModule, MatCheckboxModule, FormsModule],
})
export class SendToBlenderDialogComponent {
    readonly data = inject<SendToBlenderDialogData>(MAT_DIALOG_DATA)
    readonly dialogRef = inject(MatDialogRef<SendToBlenderDialogComponent, SendToBlenderDialogResult>)
    readonly $includeMaterials = signal(false)

    readonly counts = [
        [this.data.meshCount, "mesh", "meshes"],
        [this.data.meshCurveCount, "curve", "curves"],
        [this.data.lightCount, "light", "lights"],
        [this.data.cameraCount, "camera", "cameras"],
        [this.data.materialCount, "material", "materials"],
        [this.data.hdriCount, "HDRI", "HDRIs"],
    ]
        .filter(([count]) => count !== 0)
        .map(([count, singular, plural]) => `${count} ${count === 1 ? singular : plural}`)
        .concat(this.data.renderCount > 0 ? ["render settings"] : [])

    confirmAction(): void {
        this.dialogRef.close({includeMaterials: this.data.meshCount > 0 && this.$includeMaterials()})
    }

    cancelAction(): void {
        this.dialogRef.close()
    }
}
